import React, {
    useState,
    useEffect,
    useReducer,
    useContext,
    useRef,
    useMemo,
} from "react";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import { Facebook, Instagram, WhatsApp } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";

import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";

import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

// Imports para filtros modernos
import {
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Chip,
    Box,
    Menu,
    Tooltip,
    Card,
    CardContent,
    Collapse,
    Fade,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Checkbox,
    CircularProgress
} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import FilterListIcon from "@material-ui/icons/FilterList";
import CancelIcon from "@material-ui/icons/Cancel";
import BlockIcon from "@material-ui/icons/Block";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import AddIcon from "@material-ui/icons/Add";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";

import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactModal from "../../components/ContactModal";
import ConfirmationModal from "../../components/ConfirmationModal";

import { i18n } from "../../translate/i18n";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import MainContainer from "../../components/MainContainer";
import toastError from "../../errors/toastError";

import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../../components/Can";
import NewTicketModal from "../../components/NewTicketModal";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import formatSerializedId from '../../utils/formatSerializedId';
import { v4 as uuidv4 } from "uuid";
import { CSVLink } from "react-csv";

import {
    ArrowDropDown,
    Backup,
    ContactPhone,
    AccountBox,
    CloudUpload,
    Clear,
    Search,
    Phone,
    Email,
    AccountBalanceWallet,
    Person
} from "@material-ui/icons";

import ContactImportWpModal from "../../components/ContactImportWpModal";
import { TagsFilter } from "../../components/TagsFilter";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const reducer = (state, action) => {
    if (action.type === "LOAD_CONTACTS") {
        const contacts = action.payload;
        const newContacts = [];

        contacts.forEach((contact) => {
            const contactIndex = state.findIndex((c) => c.id === contact.id);
            if (contactIndex !== -1) {
                state[contactIndex] = contact;
            } else {
                newContacts.push(contact);
            }
        });

        return [...state, ...newContacts];
    }

    if (action.type === "UPDATE_CONTACTS") {
        const contact = action.payload;
        const contactIndex = state.findIndex((c) => c.id === contact.id);

        if (contactIndex !== -1) {
            state[contactIndex] = contact;
            return [...state];
        } else {
            return [contact, ...state];
        }
    }

    if (action.type === "DELETE_CONTACT") {
        const contactId = action.payload;

        const contactIndex = state.findIndex((c) => c.id === contactId);
        if (contactIndex !== -1) {
            state.splice(contactIndex, 1);
        }
        return [...state];
    }

    if (action.type === "RESET") {
        return [];
    }
};

const useStyles = makeStyles((theme) => ({
    mainPaper: {
        flex: 1,
        padding: theme.spacing(1),
    overflow: "hidden",
        [theme.breakpoints.down('sm')]: {
            padding: 0,
    },
    display: 'flex',
    flexDirection: 'column',
    },
    headerContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1, 0),
    },
    filtersContainer: {
        background: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
            ? theme.palette.background.paper
            : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        borderRadius: 12,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
        boxShadow: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
            ? '0 2px 6px rgba(0,0,0,0.6)'
            : '0 2px 8px rgba(0,0,0,0.1)',
        border: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
            ? '1px solid rgba(255,255,255,0.08)'
            : 'none'
    },
    searchField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            background: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                ? 'rgba(255,255,255,0.08)'
                : '#FFFFFF',
            transition: 'background .15s, box-shadow .15s, border-color .15s',
            '&:hover': {
                background: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                    ? 'rgba(255,255,255,0.12)'
                    : '#FFFFFF',
                boxShadow: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                    ? '0 0 0 1px rgba(255,255,255,0.15)'
                    : '0 2px 8px rgba(0,0,0,0.10)'
            },
            '&.Mui-focused': {
                background: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                    ? 'rgba(255,255,255,0.16)'
                    : '#FFFFFF',
                boxShadow: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                    ? `0 0 0 2px ${theme.palette.primary.main}55`
                    : '0 4px 16px rgba(0,0,0,0.15)'
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                    ? 'rgba(255,255,255,0.20)'
                    : 'rgba(0,0,0,0.23)'
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                    ? 'rgba(255,255,255,0.35)'
                    : theme.palette.primary.main
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.main
            },
            '& input': {
                color: theme.palette.text.primary,
                '&::placeholder': {
                    color: theme.palette.text.secondary,
                    opacity: 0.7
                }
            },
            '& .MuiInputAdornment-root svg': {
                color: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                    ? 'rgba(255,255,255,0.65)'
                    : 'rgba(0,0,0,0.54)'
            },
            '&.Mui-focused .MuiInputAdornment-root svg': {
                color: theme.palette.primary.main
            }
        },
        '& .MuiInputLabel-outlined': {
            color: theme.palette.text.secondary
        },
        '& .MuiInputLabel-outlined.Mui-focused': {
            color: theme.palette.primary.main
        }
    },
    selectField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            background: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                ? 'rgba(255,255,255,0.08)'
                : '#FFFFFF',
            '& .MuiSelect-select': {
                color: theme.palette.text.primary
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                    ? 'rgba(255,255,255,0.20)'
                    : 'rgba(0,0,0,0.23)'
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                    ? 'rgba(255,255,255,0.35)'
                    : theme.palette.primary.main
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.main
            },
            '& .MuiInputAdornment-root svg': {
                color: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                    ? 'rgba(255,255,255,0.65)'
                    : 'rgba(0,0,0,0.54)'
            },
            '&.Mui-focused .MuiInputAdornment-root svg': {
                color: theme.palette.primary.main
            }
        },
        '& .MuiInputLabel-outlined': {
            color: theme.palette.text.secondary
        },
        '& .MuiInputLabel-outlined.Mui-focused': {
            color: theme.palette.primary.main
        }
    },
    tagsFilterField: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 8,
            background: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                ? 'rgba(255,255,255,0.08)'
                : '#FFFFFF',
            minHeight: 40,
            paddingTop: 2,
            paddingBottom: 2,
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                    ? 'rgba(255,255,255,0.20)'
                    : 'rgba(0,0,0,0.23)'
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.type === 'dark' || theme.palette.mode === 'dark'
                    ? 'rgba(255,255,255,0.35)'
                    : theme.palette.primary.main
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.main
            },
            '& .MuiChip-root': {
                background: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                fontWeight: 500
            },
            '& .MuiChip-deleteIcon': {
                color: theme.palette.primary.contrastText
            }
        }
    },
    actionButton: {
        borderRadius: 8,
        textTransform: 'none',
        fontWeight: 600,
        margin: theme.spacing(0, 0.5),
    },
    filterChip: {
        background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        color: 'white',
        fontWeight: 600,
        '& .MuiChip-deleteIcon': {
            color: 'rgba(255, 255, 255, 0.8)',
            '&:hover': {
                color: 'white',
            }
        }
    },
    filterTitle: {
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        color: (theme.palette.type === 'dark' || theme.palette.mode === 'dark') ? '#FFFFFF' : '#333',
        '& svg': {
            marginRight: 8,
            verticalAlign: 'middle',
            color: 'inherit'
        }
    },
    lidRow: {
        display: 'grid',
        gridTemplateColumns: '40px 2fr 1.2fr 0.8fr 0.8fr 1fr 1fr',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(1, 0),
        borderBottom: `1px solid ${theme.palette.divider}`
    },
    lidRowMobile: {
        gridTemplateColumns: '40px 1fr'
    },
    lidRowBlocked: {
        opacity: 0.7,
        '& .MuiTypography-body2': {
            color: theme.palette.text.secondary
        }
    },
    lidHeaderRow: {
        fontWeight: 600,
        color: theme.palette.text.secondary
    },
    lidInteractionChip: {
        backgroundColor: theme.palette.warning.light,
        color: theme.palette.getContrastText(theme.palette.warning.light),
        fontWeight: 600
    },
    lidEmptyState: {
        padding: theme.spacing(3),
        textAlign: 'center',
        border: `1px dashed ${theme.palette.divider}`,
        borderRadius: 8,
        marginTop: theme.spacing(2)
    }
}));

const Contacts = () => {
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const history = useHistory();

    const isDark = theme.palette.type === 'dark' || theme.palette.mode === 'dark';

    //   const socketManager = useContext(SocketContext);
    const { user, socket } = useContext(AuthContext);


    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [searchParam, setSearchParam] = useState("");
    const [contacts, dispatch] = useReducer(reducer, []);
    const [selectedContactId, setSelectedContactId] = useState(null);
    const [contactModalOpen, setContactModalOpen] = useState(false);

    const [importContactModalOpen, setImportContactModalOpen] = useState(false);
    const [deletingContact, setDeletingContact] = useState(null);
    const [ImportContacts, setImportContacts] = useState(null);
    const [blockingContact, setBlockingContact] = useState(null);
    const [unBlockingContact, setUnBlockingContact] = useState(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [exportContact] = useState(false);
    const [hasMore, setHasMore] = useState(false);
    const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
    const [contactTicket, setContactTicket] = useState({});
    const fileUploadRef = useRef(null);
    const [selectedTags, setSelectedTags] = useState([]);
    const { setCurrentTicket } = useContext(TicketsContext);
    const [deletingAllContact, setDeletingAllContact] = useState(null);
    const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
    // Modal de seleção de conexões (chips)
    const [chooseConnOpen, setChooseConnOpen] = useState(false);
    const [connLoading, setConnLoading] = useState(false);
    const [connectedSessions, setConnectedSessions] = useState([]);
    const [selectedConnIds, setSelectedConnIds] = useState([]);
    const [lidCleanerOpen, setLidCleanerOpen] = useState(false);
    const [lidCleanerList, setLidCleanerList] = useState([]);
    const [lidCleanerSelectedIds, setLidCleanerSelectedIds] = useState([]);
    const [lidCleanerLoading, setLidCleanerLoading] = useState(false);
    const [lidCleanerSubmitting, setLidCleanerSubmitting] = useState(false);
    const [lidCleanerPage, setLidCleanerPage] = useState(1);
    const [lidCleanerHasMore, setLidCleanerHasMore] = useState(false);

    // Estados para filtros simplificados (removido searchName e searchNumber redundantes)
    const [filters, setFilters] = useState({
        searchEmail: "",
        channel: "",
        hasWallet: "",
        walletUserId: ""
    });
    const [walletUsers, setWalletUsers] = useState([]);
    const [whatsapps, setWhatsapps] = useState([]);
    const [tags, setTags] = useState([]);
    const [activeFiltersCount, setActiveFiltersCount] = useState(0);

    // CSV Headers para exportação
    const csvHeaders = [
        { label: "id", key: "id" },
        { label: "Nome", key: "name" },
        { label: "Email", key: "email" },
        { label: "Número", key: "number" },
    ];

    const { getAll: getAllSettings } = useCompanySettings();
    const [hideNum, setHideNum] = useState(false);
    const [enableLGPD, setEnableLGPD] = useState(false);
    useEffect(() => {

        async function fetchData() {

            const settingList = await getAllSettings(user.companyId);

            for (const [key, value] of Object.entries(settingList)) {
                
                if (key === "enableLGPD") setEnableLGPD(value === "enabled");
                if (key === "lgpdHideNumber") setHideNum(value === "enabled");
                
              }

            // if (settingHideNumber.lgpdHideNumber === "enabled") {
            //     setHideNum(true);
            // }
        }
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleImportExcel = async () => {
        try {
            const formData = new FormData();
            formData.append("file", fileUploadRef.current.files[0]);
            await api.request({
                url: `/contacts/upload`,
                method: "POST",
                data: formData,
            });
            history.go(0);
        } catch (err) {
            toastError(err);
        }
    };

    useEffect(() => {
        dispatch({ type: "RESET" });
        setPageNumber(1);
    }, [searchParam, selectedTags, filters]);

    // Carregar dados para os filtros
    useEffect(() => {
        const loadFilterData = async () => {
            try {
                // Carregar usuários para filtro de wallet
                const { data: users } = await api.get("/users");
                setWalletUsers(users.users || []);

                // Carregar WhatsApps para filtro de canal
                const { data: whatsappData } = await api.get("/whatsapp");
                setWhatsapps(whatsappData || []);
                // Popular conexões CONNECTED para o modal
                const connected = (whatsappData || []).filter(w => w.status === 'CONNECTED');
                setConnectedSessions(connected);

                // Carregar Tags para filtro de tags
                const { data: tagsResponse } = await api.get("/tags/list");
                setTags(Array.isArray(tagsResponse.tags) ? tagsResponse.tags : Array.isArray(tagsResponse) ? tagsResponse : []);
            } catch (err) {
                console.error("Erro ao carregar dados dos filtros:", err);
                // Definir arrays vazios em caso de erro
                setWalletUsers([]);
                setWhatsapps([]);
                setTags([]);
                setConnectedSessions([]);
            }
        };
        loadFilterData();
    }, []);

    // Contar filtros ativos incluindo tags
    useEffect(() => {
        const filtersCount = Object.values(filters).filter(value => 
            value !== "" && value !== null && value !== undefined
        ).length;
        
        const tagsCount = selectedTags.length > 0 ? 1 : 0;
        const searchCount = searchParam !== "" ? 1 : 0;
        
        setActiveFiltersCount(filtersCount + tagsCount + searchCount);
    }, [filters, selectedTags, searchParam]);

    useEffect(() => {
        setLoading(true);
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    const params = {
                        searchParam,
                        pageNumber,
                        contactTag: JSON.stringify(selectedTags),
                        ...filters
                    };
                    
                    const { data } = await api.get("/contacts/", { params });
                    dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
                    setHasMore(data.hasMore);
                    setLoading(false);
                } catch (err) {
                    toastError(err);
                }
            };
            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchParam, pageNumber, selectedTags, filters]);

    useEffect(() => {
        const companyId = user.companyId;
        //    const socket = socketManager.GetSocket();

        const onContactEvent = (data) => {
            if (data.action === "update" || data.action === "create") {
                dispatch({ type: "UPDATE_CONTACTS", payload: data.contact });
            }

            if (data.action === "delete") {
                dispatch({ type: "DELETE_CONTACT", payload: +data.contactId });
            }
        };
        socket.on(`company-${companyId}-contact`, onContactEvent);

        return () => {
            socket.off(`company-${companyId}-contact`, onContactEvent);
        };
    }, [socket]);

    const handleSelectTicket = (ticket) => {
        const code = uuidv4();
        const { id, uuid } = ticket;
        setCurrentTicket({ id, uuid, code });
    }

    const handleCloseOrOpenTicket = (ticket) => {
        setNewTicketModalOpen(false);
        if (ticket !== undefined && ticket.uuid !== undefined) {
            handleSelectTicket(ticket);
            history.push(`/tickets/${ticket.uuid}`);
        }
    };

    const handleSearch = (event) => {
        setSearchParam(event.target.value.toLowerCase());
    };

    const handleSelectedTags = (selecteds) => {
        const tags = selecteds.map((t) => t.id);
        setSelectedTags(tags);
    };

    const handleClearAllFilters = () => {
        setFilters({
            searchEmail: "",
            channel: "",
            hasWallet: "",
            walletUserId: ""
        });
        setSearchParam("");
        setSelectedTags([]);
    };

    const handleOpenContactModal = () => {
        setSelectedContactId(null);
        setContactModalOpen(true);
    };

    const handleCloseContactModal = () => {
        setSelectedContactId(null);
        setContactModalOpen(false);
    };

    const hadleEditContact = (contactId) => {
        setSelectedContactId(contactId);
        setContactModalOpen(true);
    };

    const handleDeleteContact = async (contactId) => {
        try {
            await api.delete(`/contacts/${contactId}`);
            toast.success(i18n.t("contacts.toasts.deleted"));
        } catch (err) {
            toastError(err);
        }
        setDeletingContact(null);
        setSearchParam("");
        setPageNumber(1);
    };

    const handleBlockContact = async (contactId) => {
        try {
            await api.put(`/contacts/block/${contactId}`, { active: false });
            toast.success("Contato bloqueado");
        } catch (err) {
            toastError(err);
        }
        setDeletingContact(null);
        setSearchParam("");
        setPageNumber(1);
        setBlockingContact(null);
    };

    const handleUnBlockContact = async (contactId) => {
        try {
            await api.put(`/contacts/block/${contactId}`, { active: true });
            toast.success("Contato desbloqueado");
        } catch (err) {
            toastError(err);
        }
        setDeletingContact(null);
        setSearchParam("");
        setPageNumber(1);
        setUnBlockingContact(null);
    };

    const handleimportContact = async () => {
        // Abrir modal para escolher conexões ao confirmar "Importar do aparelho"
        setChooseConnOpen(true);
        setImportContacts(false);
    };



    const handleDeleteAllContact = async () => {
        try {
          await api.delete("/contacts/list/DeleteAll");
          history.go(0);
        } catch (err) {
          toastError(err);
        }
    }

    // Funções para manipulação dos filtros
    const handleFilterChange = (field, value) => {
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const hasActiveFilters = () => {
        return searchParam !== "" || 
               selectedTags.length > 0 || 
               Object.values(filters).some(value => value !== "");
    };

    const loadMore = () => {
        setPageNumber((prevState) => prevState + 1);
    };

    const handleScroll = (e) => {
        if (!hasMore || loading) return;
        const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
        if (scrollHeight - (scrollTop + 100) < clientHeight) {
            loadMore();
        }
    };

    const formatContactNumber = (contactNumber, isGroup = false) => {
        if (!contactNumber) return "-";
        if (isGroup) return contactNumber;

        const serialized = formatSerializedId(contactNumber);
        if (enableLGPD && hideNum && user.profile === "user") {
            const source = serialized || contactNumber;
            if (!source || source.length <= 4) return "****";
            const start = source.slice(0, Math.max(0, source.length - 6));
            const end = source.slice(-2);
            return `${start}**-**${end}`;
        }

        return serialized || contactNumber;
    };

    const formatLidDate = (value) => {
        if (!value) return "-";
        try {
            const locale = i18n.language || navigator.language || "pt-BR";
            return new Intl.DateTimeFormat(locale, { dateStyle: "short", timeStyle: "short" }).format(new Date(value));
        } catch (err) {
            return new Date(value).toLocaleString();
        }
    };

    const getLidReasonLabel = (reason) => {
        try {
            return i18n.t(`contacts.lidCleaner.reasons.${reason}`);
        } catch (err) {
            return String(reason);
        }
    };

    const hasLidContactInteraction = (contact) => {
        if (!contact) return false;
        const tickets = Number(contact.ticketsCount || 0);
        const messages = Number(contact.messagesCount || 0);
        return tickets > 0 || messages > 0;
    };

    const selectableLidContactIds = useMemo(() =>
        lidCleanerList
            .filter((contact) => !hasLidContactInteraction(contact))
            .map((contact) => contact.id),
        [lidCleanerList]
    );

    const selectableLidContactsCount = selectableLidContactIds.length;

    const loadLidContacts = async (pageToLoad = 1, reset = false) => {
        setLidCleanerLoading(true);
        try {
            const { data } = await api.get("/contacts/lid", {
                params: {
                    page: pageToLoad,
                    pageSize: 50
                }
            });
            const sanitizedContacts = (data?.contacts || []).map((contact) => ({
                ...contact,
                ticketsCount: contact.ticketsCount || 0,
                messagesCount: contact.messagesCount || 0
            }));
            setLidCleanerList((prev) => (reset ? sanitizedContacts : [...prev, ...sanitizedContacts]));
            setLidCleanerHasMore(data.hasMore);
            setLidCleanerPage(pageToLoad);
            if (reset) {
                setLidCleanerSelectedIds([]);
            }
        } catch (err) {
            toastError(err);
        } finally {
            setLidCleanerLoading(false);
        }
    };

    const handleOpenLidCleaner = () => {
        setLidCleanerOpen(true);
        loadLidContacts(1, true);
    };

    const handleCloseLidCleaner = () => {
        if (lidCleanerSubmitting) return;
        setLidCleanerOpen(false);
    };

    const handleToggleSelectLidContact = (contactId) => {
        const targetContact = lidCleanerList.find((contact) => contact.id === contactId);
        if (hasLidContactInteraction(targetContact)) {
            toast.warning(i18n.t("contacts.lidCleaner.validation.hasMessages"));
            return;
        }
        setLidCleanerSelectedIds((prev) =>
            prev.includes(contactId)
                ? prev.filter((id) => id !== contactId)
                : [...prev, contactId]
        );
    };

    const handleToggleSelectAllLidContacts = () => {
        if (!selectableLidContactsCount) {
            toast.info(i18n.t("contacts.lidCleaner.validation.noSafeContacts"));
            return;
        }
        if (lidCleanerSelectedIds.length === selectableLidContactsCount) {
            setLidCleanerSelectedIds([]);
        } else {
            setLidCleanerSelectedIds(selectableLidContactIds);
        }
    };

    const handleDeleteSelectedLidContacts = async () => {
        if (!lidCleanerSelectedIds.length) {
            toast.warning(i18n.t("contacts.lidCleaner.validation.select"));
            return;
        }

        const invalidSelections = lidCleanerList.filter(
            (contact) => lidCleanerSelectedIds.includes(contact.id) && hasLidContactInteraction(contact)
        );

        if (invalidSelections.length) {
            toast.warning(i18n.t("contacts.lidCleaner.validation.hasMessages"));
            const invalidIds = invalidSelections.map((contact) => contact.id);
            setLidCleanerSelectedIds((prev) => prev.filter((id) => !invalidIds.includes(id)));
            return;
        }

        setLidCleanerSubmitting(true);
        try {
            const { data } = await api.delete("/contacts/lid", {
                data: { contactIds: lidCleanerSelectedIds }
            });

            const deletedCount = data?.deleted || 0;
            if (deletedCount > 0) {
                toast.success(i18n.t("contacts.lidCleaner.toasts.deleted", { count: deletedCount }));
            } else {
                toast.info(i18n.t("contacts.lidCleaner.toasts.none"));
            }

            if (Array.isArray(data?.affectedIds)) {
                data.affectedIds.forEach((id) => {
                    dispatch({ type: "DELETE_CONTACT", payload: id });
                });
            }

            await loadLidContacts(1, true);
        } catch (err) {
            toastError(err);
        } finally {
            setLidCleanerSubmitting(false);
        }
    };

    const handleLoadMoreLidContacts = () => {
        if (lidCleanerLoading || !lidCleanerHasMore) return;
        loadLidContacts(lidCleanerPage + 1, false);
    };


    // function getDateLastMessage(contact) {
    //     if (!contact) return null;
    //     if (!contact.tickets) return null;

    //     if (contact.tickets.length > 0) {
    //         const date = new Date(contact.tickets[contact.tickets.length - 1].updatedAt);

    //         const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
    //         const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
    //         const year = date.getFullYear();
    //         const hours = date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`;
    //         const minutes = date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;

    //         return `${day}/${month}/${year} ${hours}:${minutes}`;
    //     }

    //     return null;
    // }


    // Altura dinâmica da lista considerando mobile/desktop e filtro retrátil
    // Altura: usar flex em vez de cálculos fixos para evitar faixas em branco/scroll horizontal
    const listContainerStyle = isMobile
        ? { flex: 1, overflowY: 'auto', overflowX: 'hidden' }
        : { flex: 1, overflowY: 'auto', overflowX: 'hidden' };

    return (

    <MainContainer className={classes.mainContainer} style={{ paddingBottom: 0 }}>
            <NewTicketModal
                modalOpen={newTicketModalOpen}
                initialContact={contactTicket}
                onClose={(ticket) => {
                    handleCloseOrOpenTicket(ticket);
                }}
            />
            <ContactModal
                open={contactModalOpen}
                onClose={handleCloseContactModal}
                aria-labelledby="form-dialog-title"
                contactId={selectedContactId}
            ></ContactModal>
            <ConfirmationModal
                title={
                    deletingContact
                        ? `${i18n.t(
                            "contacts.confirmationModal.deleteTitle"
                        )} ${deletingContact.name}?`
                        : blockingContact
                            ? `Bloquear Contato ${blockingContact.name}?`
                            : unBlockingContact
                                ? `Desbloquear Contato ${unBlockingContact.name}?`
                                : ImportContacts
                                    ? `${i18n.t("contacts.confirmationModal.importTitlte")}` 
                                    : deletingAllContact 
                                    ? `${i18n.t("contacts.confirmationModal.deleteAllTitle")}`
                                        : `${i18n.t("contactListItems.confirmationModal.importTitlte")}`
                }
                open={confirmOpen}
                onClose={setConfirmOpen}
                onConfirm={(e) =>
                    deletingContact
                        ? handleDeleteContact(deletingContact.id)
                        : blockingContact
                            ? handleBlockContact(blockingContact.id)
                            : unBlockingContact
                                ? handleUnBlockContact(unBlockingContact.id)
                                : ImportContacts
                                ? handleimportContact()
                                    : deletingAllContact
                                    ? handleDeleteAllContact()
                                    : handleImportExcel()
                }
            >
                {exportContact
                    ?
                    `${i18n.t("contacts.confirmationModal.exportContact")}`
                    : deletingContact
                        ? `${i18n.t("contacts.confirmationModal.deleteMessage")}`
                        : blockingContact
                            ? `${i18n.t("contacts.confirmationModal.blockContact")}`
                            : unBlockingContact
                                ? `${i18n.t("contacts.confirmationModal.unblockContact")}`
                                : ImportContacts
                                    ? `${i18n.t("contacts.confirmationModal.importMessage")}`
                                    : `${i18n.t(
                                        "contactListItems.confirmationModal.importMessage"
                                    )}`}
            </ConfirmationModal>

            <Dialog
                open={lidCleanerOpen}
                onClose={handleCloseLidCleaner}
                fullWidth
                maxWidth="md"
                aria-labelledby="lid-cleaner-dialog-title"
            >
                <DialogTitle disableTypography id="lid-cleaner-dialog-title">
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Box>
                            <Typography variant="h6">
                                {i18n.t("contacts.lidCleaner.title")}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                {i18n.t("contacts.lidCleaner.subtitle", { total: lidCleanerList.length })}
                            </Typography>
                        </Box>
                        <IconButton onClick={handleCloseLidCleaner} disabled={lidCleanerSubmitting}>
                            <ClearIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2" color="textSecondary">
                        {i18n.t("contacts.lidCleaner.description")}
                    </Typography>

                    <Box display="flex" alignItems="center" justifyContent="space-between" mt={2}>
                        <Typography variant="subtitle2">
                            {i18n.t("contacts.lidCleaner.selection", { count: lidCleanerSelectedIds.length })}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                            {i18n.t("contacts.lidCleaner.total", { count: lidCleanerList.length })}
                        </Typography>
                    </Box>

                    {lidCleanerLoading && !lidCleanerList.length ? (
                        <Box display="flex" alignItems="center" justifyContent="center" mt={4} mb={2}>
                            <CircularProgress size={32} />
                        </Box>
                    ) : lidCleanerList.length ? (
                        <>
                            {!isMobile && (
                                <Box
                                    className={`${classes.lidRow} ${classes.lidHeaderRow}`}
                                    mt={2}
                                >
                                    <Box display="flex" alignItems="center">
                                        <Checkbox
                                            color="primary"
                                            checked={Boolean(selectableLidContactsCount) && lidCleanerSelectedIds.length === selectableLidContactsCount}
                                            indeterminate={lidCleanerSelectedIds.length > 0 && lidCleanerSelectedIds.length < selectableLidContactsCount}
                                            onChange={handleToggleSelectAllLidContacts}
                                            disabled={!selectableLidContactsCount || lidCleanerLoading}
                                        />
                                        <Typography variant="caption">
                                            {i18n.t("contacts.lidCleaner.columns.select")}
                                        </Typography>
                                    </Box>
                                    <Typography variant="caption">
                                        {i18n.t("contacts.lidCleaner.columns.contact")}
                                    </Typography>
                                    <Typography variant="caption">
                                        {i18n.t("contacts.lidCleaner.columns.reason")}
                                    </Typography>
                                    <Typography variant="caption">
                                        {i18n.t("contacts.lidCleaner.columns.tickets")}
                                    </Typography>
                                    <Typography variant="caption">
                                        {i18n.t("contacts.lidCleaner.columns.messages")}
                                    </Typography>
                                    <Typography variant="caption">
                                        {i18n.t("contacts.lidCleaner.columns.lastInteraction")}
                                    </Typography>
                                    <Typography variant="caption">
                                        {i18n.t("contacts.lidCleaner.columns.updatedAt")}
                                    </Typography>
                                </Box>
                            )}

                            {lidCleanerList.map((contact) => {
                                const ticketsCount = Number(contact.ticketsCount || 0);
                                const messagesCount = Number(contact.messagesCount || 0);
                                const contactHasInteraction = ticketsCount > 0 || messagesCount > 0;

                                return (
                                    <Box
                                        key={contact.id}
                                        className={`${classes.lidRow} ${isMobile ? classes.lidRowMobile : ""} ${contactHasInteraction ? classes.lidRowBlocked : ""}`}
                                    >
                                        <Tooltip
                                            title={contactHasInteraction ? i18n.t("contacts.lidCleaner.validation.hasMessages") : ""}
                                            placement="top"
                                            disableHoverListener={!contactHasInteraction}
                                            disableFocusListener={!contactHasInteraction}
                                        >
                                            <span>
                                                <Checkbox
                                                    color="primary"
                                                    checked={lidCleanerSelectedIds.includes(contact.id)}
                                                    onChange={() => handleToggleSelectLidContact(contact.id)}
                                                    disabled={lidCleanerSubmitting || contactHasInteraction}
                                                />
                                            </span>
                                        </Tooltip>
                                        <Box minWidth={0} display="flex" flexDirection="column">
                                            <Typography variant="subtitle2" noWrap>
                                                {contact.name || "-"}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                {formatContactNumber(contact.number, contact.isGroup)}
                                            </Typography>
                                        </Box>
                                        <Box display="flex" flexDirection="column" style={{ gap: 4 }}>
                                            <Chip
                                                size="small"
                                                color="secondary"
                                                label={getLidReasonLabel(contact.suspectedReason)}
                                            />
                                            {contactHasInteraction && (
                                                <Chip
                                                    size="small"
                                                    label={i18n.t("contacts.lidCleaner.badges.hasInteraction")}
                                                    className={classes.lidInteractionChip}
                                                />
                                            )}
                                        </Box>
                                        <Box>
                                            <Typography variant="caption" color="textSecondary">
                                                {i18n.t("contacts.lidCleaner.columns.tickets")}
                                            </Typography>
                                            <Typography variant="body2">
                                                {ticketsCount}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography variant="caption" color="textSecondary">
                                                {i18n.t("contacts.lidCleaner.columns.messages")}
                                            </Typography>
                                            <Typography variant="body2">
                                                {messagesCount}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography variant="caption" color="textSecondary">
                                                {i18n.t("contacts.lidCleaner.columns.lastInteraction")}
                                            </Typography>
                                            <Typography variant="body2">
                                                {formatLidDate(contact.lastInteractionAt)}
                                            </Typography>
                                        </Box>
                                        <Box>
                                            <Typography variant="caption" color="textSecondary">
                                                {i18n.t("contacts.lidCleaner.columns.updatedAt")}
                                            </Typography>
                                            <Typography variant="body2">
                                                {formatLidDate(contact.updatedAt)}
                                            </Typography>
                                        </Box>
                                    </Box>
                                );
                            })}

                            {lidCleanerHasMore && (
                                <Box textAlign="center" mt={2}>
                                    <Button
                                        variant="outlined"
                                        onClick={handleLoadMoreLidContacts}
                                        disabled={lidCleanerLoading}
                                    >
                                        {lidCleanerLoading
                                            ? i18n.t("contacts.lidCleaner.loading")
                                            : i18n.t("contacts.lidCleaner.actions.loadMore")}
                                    </Button>
                                </Box>
                            )}
                        </>
                    ) : (
                        <Box className={classes.lidEmptyState} mt={2}>
                            <Typography variant="subtitle1">
                                {i18n.t("contacts.lidCleaner.empty")}
                            </Typography>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseLidCleaner} disabled={lidCleanerSubmitting}>
                        {i18n.t("contacts.lidCleaner.actions.close")}
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleDeleteSelectedLidContacts}
                        disabled={lidCleanerSubmitting || !lidCleanerSelectedIds.length}
                        startIcon={<DeleteSweepIcon />}
                    >
                        {lidCleanerSubmitting
                            ? i18n.t("contacts.lidCleaner.actions.deleting")
                            : i18n.t("contacts.lidCleaner.actions.deleteSelected", { count: lidCleanerSelectedIds.length })}
                    </Button>
                </DialogActions>
            </Dialog>

            <Paper
                className={classes.mainPaper}
                variant={isMobile ? "elevation" : "outlined"}
                elevation={isMobile ? 0 : 1}
                square={isMobile}
                style={ isMobile ? { border: 'none', borderRadius: 0, paddingBottom: 8 } : undefined }
            >
                {/* Header & ações: responsivo */}
                {isMobile ? (
                    <Box className={classes.headerContainer} style={{ flexDirection: 'column', alignItems: 'stretch', gap: 8, paddingLeft: 16, paddingRight: 16, width: '100%', boxSizing: 'border-box' }}>
                        <Title>
                            {i18n.t("contacts.title")} ({contacts.length})
                            {activeFiltersCount > 0 && (
                                <Chip 
                                    label={`${activeFiltersCount} filtro${activeFiltersCount > 1 ? 's' : ''} ativo${activeFiltersCount > 1 ? 's' : ''}`}
                                    size="small"
                                    className={classes.filterChip}
                                    style={{ marginLeft: 8 }}
                                />
                            )}
                        </Title>
                        <Box display="flex" alignItems="center" flexWrap="wrap" style={{ gap: 8 }}>
                            <Button
                                className={classes.actionButton}
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={handleOpenContactModal}
                                startIcon={<AddIcon />}
                            >
                                {i18n.t("contacts.buttons.add")}
                            </Button>
                            <Button
                                className={classes.actionButton}
                                size="small"
                                variant="outlined"
                                color="secondary"
                                onClick={handleOpenLidCleaner}
                                startIcon={<DeleteSweepIcon />}
                            >
                                {i18n.t("contacts.lidCleaner.button")}
                            </Button>
                            {user.profile === "admin" && (
                                <>
                                    <PopupState variant="popover" popupId="import-export-menu">
                                        {(popupState) => (
                                            <>
                                                <Button
                                                    className={classes.actionButton}
                                                    size="small"
                                                    variant="outlined"
                                                    color="primary"
                                                    {...bindTrigger(popupState)}
                                                    endIcon={<ArrowDropDown />}
                                                >
                                                    Importar / Exportar
                                                </Button>
                                                <Menu {...bindMenu(popupState)}>
                                                    <MenuItem onClick={() => { setConfirmOpen(true); setImportContacts(true); popupState.close(); }}>
                                                        <ContactPhone fontSize="small" color="primary" style={{ marginRight: 10 }} />
                                                        {i18n.t("contacts.menu.importYourPhone")}
                                                    </MenuItem>
                                                    <MenuItem onClick={() => { setImportContactModalOpen(true); popupState.close(); }}>
                                                        <Backup fontSize="small" color="primary" style={{ marginRight: 10 }} />
                                                        {i18n.t("contacts.menu.importToExcel")}
                                                    </MenuItem>
                                                    <MenuItem onClick={() => { fileUploadRef.current.click(); popupState.close(); }}>
                                                        <CloudUpload fontSize="small" color="primary" style={{ marginRight: 10 }} />
                                                        Importar Excel
                                                    </MenuItem>
                                                    <MenuItem>
                                                        <CSVLink
                                                            style={{ textDecoration: "none", color: "inherit", display: "flex", alignItems: "center", width: "100%" }}
                                                            separator=";"
                                                            filename={'contacts.csv'}
                                                            headers={csvHeaders}
                                                            data={contacts.map((contact) => ({
                                                                number: hideNum && user.profile === "user" 
                                                                    ? contact.isGroup 
                                                                        ? contact.number 
                                                                        : formatSerializedId(contact.number)?.slice(0,-6)+"**-**"+ contact.number.slice(-2)
                                                                    : contact.isGroup 
                                                                        ? contact.number 
                                                                        : formatSerializedId(contact.number),
                                                                firstName: contact.name.split(' ')[0],
                                                                lastname: String(contact.name).replace(contact.name.split(' ')[0],''),
                                                                email: contact.email,
                                                                tags: contact?.tags?.map(tag => tag.name).join(', ') || ''
                                                            }))}
                                                            onClick={() => popupState.close()}
                                                        >
                                                            <CloudDownloadIcon fontSize="small" color="primary" style={{ marginRight: 10 }} />
                                                            Exportar Excel
                                                        </CSVLink>
                                                    </MenuItem>
                                                </Menu>
                                            </>
                                        )}
                                    </PopupState>
                                    <Button className={classes.actionButton} size="small" variant="outlined" color="primary" onClick={() => setChooseConnOpen(true)} startIcon={<ContactPhone />}>Importar do Aparelho</Button>
                                    <Button className={classes.actionButton} size="small" variant="outlined" style={{ color: "#f44336", borderColor: "#f44336" }} onClick={() => { setDeletingAllContact(true); setConfirmOpen(true); }} startIcon={<DeleteOutlineIcon />}>{i18n.t("contacts.buttons.deleteAllContacts")}</Button>
                                </>
                            )}
                        </Box>
                        <Box mt={1}>
                            <Button size="small" variant="outlined" startIcon={<FilterListIcon />} onClick={() => setMobileFiltersOpen(v => !v)}>
                                {mobileFiltersOpen ? 'Ocultar filtros' : 'Mostrar filtros'}
                            </Button>
                        </Box>
                    </Box>
                ) : (
                    <>
                        {/* Desktop: Mantém como estava */}
                        <Box className={classes.headerContainer} style={{ paddingLeft: 8, paddingRight: 8 }}>
                            <Title>
                                {i18n.t("contacts.title")} ({contacts.length})
                                {activeFiltersCount > 0 && (
                                    <Chip 
                                        label={`${activeFiltersCount} filtro${activeFiltersCount > 1 ? 's' : ''} ativo${activeFiltersCount > 1 ? 's' : ''}`}
                                        size="small"
                                        className={classes.filterChip}
                                        style={{ marginLeft: 8 }}
                                    />
                                )}
                            </Title>
                            
                            <Box display="flex" alignItems="center" gap={1}>
                                <Button
                                    className={classes.actionButton}
                                    variant="outlined"
                                    color="secondary"
                                    onClick={handleOpenLidCleaner}
                                    startIcon={<DeleteSweepIcon />}
                                >
                                    {i18n.t("contacts.lidCleaner.button")}
                                </Button>
                                <Button className={classes.actionButton} variant="contained" color="primary" onClick={handleOpenContactModal} startIcon={<AddIcon />}>{i18n.t("contacts.buttons.add")}</Button>
                                {user.profile === "admin" && (
                                    <>
                                        <PopupState variant="popover" popupId="import-export-menu">
                                            {(popupState) => (
                                                <>
                                                    <Button className={classes.actionButton} variant="contained" color="primary" {...bindTrigger(popupState)} endIcon={<ArrowDropDown />}>Importar / Exportar</Button>
                                                    <Menu {...bindMenu(popupState)}>
                                                        <MenuItem onClick={() => { setConfirmOpen(true); setImportContacts(true); popupState.close(); }}>
                                                            <ContactPhone fontSize="small" color="primary" style={{ marginRight: 10 }} />
                                                            {i18n.t("contacts.menu.importYourPhone")}
                                                        </MenuItem>
                                                        <MenuItem onClick={() => { setImportContactModalOpen(true); popupState.close(); }}>
                                                            <Backup fontSize="small" color="primary" style={{ marginRight: 10 }} />
                                                            {i18n.t("contacts.menu.importToExcel")}
                                                        </MenuItem>
                                                        <MenuItem onClick={() => { fileUploadRef.current.click(); popupState.close(); }}>
                                                            <CloudUpload fontSize="small" color="primary" style={{ marginRight: 10 }} />
                                                            Importar Excel
                                                        </MenuItem>
                                                        <MenuItem>
                                                            <CSVLink style={{ textDecoration: "none", color: "inherit", display: "flex", alignItems: "center", width: "100%" }} separator=";" filename={'contacts.csv'} headers={csvHeaders} data={contacts.map((contact) => ({
                                                                number: hideNum && user.profile === "user" 
                                                                    ? contact.isGroup 
                                                                        ? contact.number 
                                                                        : formatSerializedId(contact.number)?.slice(0,-6)+"**-**"+ contact.number.slice(-2)
                                                                    : contact.isGroup 
                                                                        ? contact.number 
                                                                        : formatSerializedId(contact.number),
                                                                firstName: contact.name.split(' ')[0],
                                                                lastname: String(contact.name).replace(contact.name.split(' ')[0],''),
                                                                email: contact.email,
                                                                tags: contact?.tags?.map(tag => tag.name).join(', ') || ''
                                                            }))} onClick={() => popupState.close()}>
                                                                <CloudDownloadIcon fontSize="small" color="primary" style={{ marginRight: 10 }} />
                                                                Exportar Excel
                                                            </CSVLink>
                                                        </MenuItem>
                                                    </Menu>
                                                </>
                                            )}
                                        </PopupState>
                                        <Button className={classes.actionButton} variant="outlined" color="primary" onClick={() => setChooseConnOpen(true)} startIcon={<ContactPhone />}>Importar do Aparelho</Button>
                                        <Button className={classes.actionButton} variant="outlined" style={{ color: "#f44336", borderColor: "#f44336" }} onClick={() => { setDeletingAllContact(true); setConfirmOpen(true); }} startIcon={<DeleteOutlineIcon />}>{i18n.t("contacts.buttons.deleteAllContacts")}</Button>
                                    </>
                                )}
                            </Box>
                        </Box>
                    </>
                )}

                {/* Filtros Modernos e Organizados */}
                {isMobile ? (
                    <Collapse in={mobileFiltersOpen}>
                        <Card className={classes.filtersContainer} elevation={0} style={{ boxShadow: 'none', borderRadius: 0, paddingLeft: 16, paddingRight: 16, width: '100%', boxSizing: 'border-box' }}>
                            <CardContent>
                                <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                                    <Typography variant="h6" className={classes.filterTitle}>
                                        <FilterListIcon />
                                        Filtros de Busca
                                    </Typography>
                                    {activeFiltersCount > 0 && (
                                        <Button size="small" onClick={handleClearAllFilters} startIcon={<Clear />} style={{ color: '#f44336' }}>
                                            Limpar ({activeFiltersCount})
                                        </Button>
                                    )}
                                </Box>
                                {/* Conteúdo de filtros original */}
                                <Grid container spacing={2}>
                                    {/* Busca Geral */}
                                    <Grid item xs={12} md={4}>
                                        <TextField className={classes.searchField} fullWidth label="Busca Geral (Nome ou Número)" variant="outlined" size="small" value={searchParam} onChange={handleSearch} InputProps={{ startAdornment: (<InputAdornment position="start"><Search /></InputAdornment>) }} />
                                    </Grid>
                                    {/* TagsFilter */}
                                    <Grid item xs={12} md={4}>
                                        <TagsFilter onFiltered={handleSelectedTags} className={classes.tagsFilterField} />
                                    </Grid>
                                    {/* Email */}
                                    <Grid item xs={12} md={4}>
                                        <TextField className={classes.searchField} fullWidth label="Email" variant="outlined" size="small" value={filters.searchEmail} onChange={(e) => setFilters({...filters, searchEmail: e.target.value})} InputProps={{ startAdornment: (<InputAdornment position="start"><Email /></InputAdornment>) }} />
                                    </Grid>
                                    {/* Canal */}
                                    <Grid item xs={12} md={4}>
                                        <FormControl variant="outlined" size="small" fullWidth className={classes.selectField}>
                                            <InputLabel>Canal WhatsApp</InputLabel>
                                            <Select value={filters.channel} onChange={(e) => setFilters({...filters, channel: e.target.value})} label="Canal WhatsApp" startAdornment={<InputAdornment position="start"><WhatsApp /></InputAdornment>}>
                                                <MenuItem value=""><em>Todos os canais</em></MenuItem>
                                                {whatsapps.map((whatsapp) => (<MenuItem key={whatsapp.id} value={whatsapp.id}>{whatsapp.name}</MenuItem>))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {/* Tem Carteira */}
                                    <Grid item xs={12} md={4}>
                                        <FormControl variant="outlined" size="small" fullWidth className={classes.selectField}>
                                            <InputLabel>Possui Carteira</InputLabel>
                                            <Select value={filters.hasWallet} onChange={(e) => setFilters({...filters, hasWallet: e.target.value})} label="Possui Carteira" startAdornment={<InputAdornment position="start"><AccountBalanceWallet /></InputAdornment>}>
                                                <MenuItem value=""><em>Todos</em></MenuItem>
                                                <MenuItem value="true">Com Carteira</MenuItem>
                                                <MenuItem value="false">Sem Carteira</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {/* Usuário da Carteira */}
                                    <Grid item xs={12} md={4}>
                                        <FormControl variant="outlined" size="small" fullWidth className={classes.selectField}>
                                            <InputLabel>Usuário da Carteira</InputLabel>
                                            <Select value={filters.walletUserId} onChange={(e) => setFilters({...filters, walletUserId: e.target.value})} label="Usuário da Carteira" startAdornment={<InputAdornment position="start"><Person /></InputAdornment>}>
                                                <MenuItem value=""><em>Todos os usuários</em></MenuItem>
                                                {walletUsers.map((user) => (<MenuItem key={user.id} value={user.id}>{user.name}</MenuItem>))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Collapse>
                ) : (
                    <Card className={classes.filtersContainer} elevation={3} style={{ marginLeft: 8, marginRight: 8 }}>
                        <CardContent>
                        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                            <Typography variant="h6" className={classes.filterTitle}>
                                <FilterListIcon />
                                Filtros de Busca
                            </Typography>
                            {activeFiltersCount > 0 && (
                                <Button
                                    size="small"
                                    onClick={handleClearAllFilters}
                                    startIcon={<Clear />}
                                    style={{ color: '#f44336' }}
                                >
                                    Limpar ({activeFiltersCount})
                                </Button>
                            )}
                        </Box>
                        
                        <Grid container spacing={2}>
                            {/* Busca Geral */}
                            <Grid item xs={12} md={4}>
                                <TextField
                                    className={classes.searchField}
                                    fullWidth
                                    label="Busca Geral (Nome ou Número)"
                                    variant="outlined"
                                    size="small"
                                    value={searchParam}
                                    onChange={handleSearch}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            
                            {/* TagsFilter Component Original */}
                            <Grid item xs={12} md={4}>
                                <TagsFilter
                                    onFiltered={handleSelectedTags}
                                    className={classes.tagsFilterField}
                                />
                            </Grid>
                            
                            {/* Email */}
                            <Grid item xs={12} md={4}>
                                <TextField
                                    className={classes.searchField}
                                    fullWidth
                                    label="Email"
                                    variant="outlined"
                                    size="small"
                                    value={filters.searchEmail}
                                    onChange={(e) => setFilters({...filters, searchEmail: e.target.value})}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Email />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            
                            {/* Canal */}
                            <Grid item xs={12} md={4}>
                                <FormControl variant="outlined" size="small" fullWidth className={classes.selectField}>
                                    <InputLabel>Canal WhatsApp</InputLabel>
                                    <Select
                                        value={filters.channel}
                                        onChange={(e) => setFilters({...filters, channel: e.target.value})}
                                        label="Canal WhatsApp"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <WhatsApp />
                                            </InputAdornment>
                                        }
                                    >
                                        <MenuItem value="">
                                            <em>Todos os canais</em>
                                        </MenuItem>
                                        {whatsapps.map((whatsapp) => (
                                            <MenuItem key={whatsapp.id} value={whatsapp.id}>
                                                {whatsapp.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            
                            {/* Tem Carteira */}
                            <Grid item xs={12} md={4}>
                                <FormControl variant="outlined" size="small" fullWidth className={classes.selectField}>
                                    <InputLabel>Possui Carteira</InputLabel>
                                    <Select
                                        value={filters.hasWallet}
                                        onChange={(e) => setFilters({...filters, hasWallet: e.target.value})}
                                        label="Possui Carteira"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <AccountBalanceWallet />
                                            </InputAdornment>
                                        }
                                    >
                                        <MenuItem value="">
                                            <em>Todos</em>
                                        </MenuItem>
                                        <MenuItem value="true">Com Carteira</MenuItem>
                                        <MenuItem value="false">Sem Carteira</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            
                            {/* Usuário da Carteira */}
                            <Grid item xs={12} md={4}>
                                <FormControl variant="outlined" size="small" fullWidth className={classes.selectField}>
                                    <InputLabel>Usuário da Carteira</InputLabel>
                                    <Select
                                        value={filters.walletUserId}
                                        onChange={(e) => setFilters({...filters, walletUserId: e.target.value})}
                                        label="Usuário da Carteira"
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <Person />
                                            </InputAdornment>
                                        }
                                    >
                                        <MenuItem value="">
                                            <em>Todos os usuários</em>
                                        </MenuItem>
                                        {walletUsers.map((user) => (
                                            <MenuItem key={user.id} value={user.id}>
                                                {user.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                )}

                {/* Upload input */}
                <input
                    style={{ display: "none" }}
                    id="upload"
                    name="file"
                    type="file"
                    accept=".xls,.xlsx"
                    onChange={() => {
                        setConfirmOpen(true);
                    }}
                    ref={fileUploadRef}
                />

                {/* Lista: mobile (2 linhas) | Tabela: desktop */}
                <div onScroll={handleScroll} style={listContainerStyle}>
                    {isMobile ? (
                        <Box style={{ width: '100%', boxSizing: 'border-box', paddingBottom: 8 }}>
                            {contacts.map((contact) => (
                                <Box key={contact.id} style={{ borderBottom: '1px solid #eee', padding: '10px 16px', width: '100%', boxSizing: 'border-box' }}>
                                    {/* Linha 1: Avatar + Nome (ellipsis) + Número */}
                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                                        <Avatar src={`${contact?.urlPicture}`} />
                                        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                                            <Box style={{ minWidth: 0, flex: 1, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {contact.name}
                                            </Box>
                                            <Box ml={1} style={{ whiteSpace: 'nowrap', color: isDark ? theme.palette.common.white : '#555', fontSize: '0.85rem' }}>
                                                {((enableLGPD && hideNum && user.profile === "user")
                                                    ? contact.isGroup
                                                        ? contact.number
                                                        : (formatSerializedId(contact?.number) === null
                                                            ? contact.number.slice(0, -6) + "**-**" + contact?.number.slice(-2)
                                                            : formatSerializedId(contact?.number)?.slice(0, -6) + "**-**" + contact?.number?.slice(-2))
                                                    : (contact.isGroup ? contact.number : formatSerializedId(contact?.number))
                                                )}
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Linha 2: Carteira + Ações */}
                                    <Box mt={0.5} display="flex" alignItems="center" justifyContent="space-between">
                                        <Box display="flex" alignItems="center" style={{ gap: 6, minWidth: 0 }}>
                                            {contact.wallets && contact.wallets.length > 0 ? (
                                                <Box display="flex" alignItems="center" style={{ gap: 4, minWidth: 0 }}>
                                                    <AccountBox style={{ color: '#1976d2' }} fontSize="small" />
                                                    <Box style={{ color: '#1976d2', fontWeight: 500, fontSize: '0.8rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                        {contact.wallets[0].name}
                                                    </Box>
                                                </Box>
                                            ) : (
                                                <Box style={{ fontSize: '0.8rem', color: '#888' }}>-</Box>
                                            )}
                                        </Box>
                                        <Box display="flex" alignItems="center">
                                            <IconButton size="small" disabled={!contact.active} onClick={() => { setContactTicket(contact); setNewTicketModalOpen(true); }}>
                                                {contact.channel === "whatsapp" && (<WhatsApp style={{ color: "green" }} />)}
                                                {contact.channel === "instagram" && (<Instagram style={{ color: "purple" }} />)}
                                                {contact.channel === "facebook" && (<Facebook style={{ color: "blue" }} />)}
                                            </IconButton>
                                            <IconButton size="small" onClick={() => hadleEditContact(contact.id)}>
                                                <EditIcon color="secondary" />
                                            </IconButton>
                                            <IconButton size="small" onClick={ contact.active ? () => { setConfirmOpen(true); setBlockingContact(contact); } : () => { setConfirmOpen(true); setUnBlockingContact(contact); } }>
                                                {contact.active ? (
                                                    <BlockIcon color="secondary" />
                                                ) : (
                                                    <CheckCircleIcon color="secondary" />
                                                )}
                                            </IconButton>
                                            <Can role={user.profile} perform="contacts-page:deleteContact" yes={() => (
                                                <IconButton size="small" onClick={(e) => { setConfirmOpen(true); setDeletingContact(contact); }}>
                                                    <DeleteOutlineIcon color="secondary" />
                                                </IconButton>
                                            )} />
                                        </Box>
                                    </Box>
                                </Box>
                            ))}
                            {loading && <TableRowSkeleton avatar columns={7} />}
                        </Box>
                    ) : (
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell padding="checkbox" />
                                    <TableCell>{i18n.t("contacts.table.name")}</TableCell>
                                    <TableCell align="center">Número</TableCell>
                                    <TableCell align="center">{i18n.t("contacts.table.email")}</TableCell>
                                    <TableCell align="center">Conexão</TableCell>
                                    <TableCell align="center">Status</TableCell>
                                    <TableCell align="center">Carteira</TableCell>
                                    <TableCell align="center">{i18n.t("contacts.table.actions")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {contacts.map((contact) => (
                                    <TableRow key={contact.id}>
                                        <TableCell style={{ paddingRight: 0 }}>
                                            {<Avatar src={`${contact?.urlPicture}`} />}
                                        </TableCell>
                                        <TableCell>{contact.name}</TableCell>
                                        <TableCell align="center">
                                            {((enableLGPD && hideNum && user.profile === "user")
                                                ? contact.isGroup
                                                    ? contact.number :
                                                    formatSerializedId(contact?.number) === null ? contact.number.slice(0, -6) + "**-**" + contact?.number.slice(-2) :
                                                        formatSerializedId(contact?.number)?.slice(0, -6) + "**-**" + contact?.number?.slice(-2) :
                                                        contact.isGroup ? contact.number : formatSerializedId(contact?.number)
                                            )}
                                        </TableCell>
                                        <TableCell align="center">
                                            {contact.email}
                                        </TableCell>
                                        <TableCell>{contact?.whatsapp?.name}</TableCell>
                                        <TableCell align="center">
                                            {contact.active ? (
                                                <CheckCircleIcon
                                                    style={{ color: "green" }}
                                                    fontSize="small"
                                                />
                                            ) : (
                                                <CancelIcon
                                                    style={{ color: "red" }}
                                                    fontSize="small"
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell align="center">
                                            {contact.wallets && contact.wallets.length > 0 ? (
                                                <Tooltip 
                                                    title={`Vinculado à carteira de clientes do usuário: ${contact.wallets.map(w => w.name).join(', ')}`}
                                                    arrow
                                                >
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px' }}>
                                                        <AccountBox 
                                                            style={{ color: "#1976d2" }}
                                                            fontSize="small"
                                                        />
                                                        <span style={{ fontSize: '0.75rem', color: '#1976d2', fontWeight: 500 }}>
                                                            {contact.wallets[0].name}
                                                        </span>
                                                    </div>
                                                </Tooltip>
                                            ) : (
                                                <span>-</span>
                                            )}
                                        </TableCell>
                                        <TableCell align="center">
                                            <IconButton
                                                size="small"
                                                disabled={!contact.active}
                                                onClick={() => {
                                                    setContactTicket(contact);
                                                    setNewTicketModalOpen(true);
                                                }}
                                            >
                                                {contact.channel === "whatsapp" && (<WhatsApp style={{ color: "green" }} />)}
                                                {contact.channel === "instagram" && (<Instagram style={{ color: "purple" }} />)}
                                                {contact.channel === "facebook" && (<Facebook style={{ color: "blue" }} />)}
                                            </IconButton>

                                            <IconButton
                                                size="small"
                                                onClick={() =>
                                                    hadleEditContact(contact.id)
                                                }
                                            >
                                                <EditIcon color="secondary" />
                                            </IconButton>
                                            <IconButton
                                                size="small"
                                                onClick={
                                                    contact.active
                                                        ? () => {
                                                            setConfirmOpen(true);
                                                            setBlockingContact(
                                                                contact
                                                            );
                                                        }
                                                        : () => {
                                                            setConfirmOpen(true);
                                                            setUnBlockingContact(
                                                                contact
                                                            );
                                                        }
                                                }
                                            >
                                                {contact.active ? (
                                                    <BlockIcon color="secondary" />
                                                ) : (
                                                    <CheckCircleIcon color="secondary" />
                                                )}
                                            </IconButton>
                                            <Can
                                                role={user.profile}
                                                perform="contacts-page:deleteContact"
                                                yes={() => (
                                                    <IconButton
                                                        size="small"
                                                        onClick={(e) => {
                                                            setConfirmOpen(true);
                                                            setDeletingContact(
                                                                contact
                                                            );
                                                        }}
                                                    >
                                                        <DeleteOutlineIcon color="secondary" />
                                                    </IconButton>
                                                )}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {loading && <TableRowSkeleton avatar columns={7} />}
                            </TableBody>
                        </Table>
                    )}
                </div>
            </Paper>

            {/* Modal: Selecionar conexões para importar contatos do aparelho */}
            {chooseConnOpen && (
                <Dialog open={chooseConnOpen} onClose={() => setChooseConnOpen(false)} maxWidth="sm" fullWidth>
                    <DialogTitle>Selecione as conexões (chips) para importar</DialogTitle>
                    <DialogContent dividers>
                        {connectedSessions.length === 0 ? (
                            <Typography color="textSecondary">Nenhuma conexão CONNECTED disponível.</Typography>
                        ) : (
                            <Box>
                                {/* Selecionar todos */}
                                <Box display="flex" alignItems="center" mb={2}>
                                    <input
                                        type="checkbox"
                                        id="conn-select-all"
                                        checked={selectedConnIds.length === connectedSessions.length && connectedSessions.length > 0}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setSelectedConnIds(checked ? connectedSessions.map(w => w.id) : []);
                                        }}
                                    />
                                    <label htmlFor="conn-select-all" style={{ marginLeft: 8, fontWeight: 600 }}>
                                        Selecionar todos
                                    </label>
                                </Box>

                                {connectedSessions.map((w) => (
                                    <Box key={w.id} display="flex" alignItems="center" mb={1}>
                                        <input
                                            type="checkbox"
                                            id={`conn-${w.id}`}
                                            checked={selectedConnIds.includes(w.id)}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                setSelectedConnIds(prev => checked ? [...prev, w.id] : prev.filter(id => id !== w.id));
                                            }}
                                        />
                                        <label htmlFor={`conn-${w.id}`} style={{ marginLeft: 8 }}>
                                            {w.name || 'WhatsApp'} — {w.number || ''} (ID {w.id})
                                        </label>
                                    </Box>
                                ))}
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setChooseConnOpen(false)}>Cancelar</Button>
                        <Button
                            color="primary"
                            variant="contained"
                            disabled={connLoading || connectedSessions.length === 0 || selectedConnIds.length === 0}
                            onClick={async () => {
                                try {
                                    setConnLoading(true);
                                    if (selectedConnIds.length === 1) {
                                        await api.post(`/contacts/import`, { whatsappId: selectedConnIds[0] });
                                    } else {
                                        await api.post(`/contacts/import`, { whatsappId: selectedConnIds });
                                    }
                                    toast.success('Importação iniciada com sucesso.');
                                    setChooseConnOpen(false);
                                    setSelectedConnIds([]);
                                    history.go(0);
                                } catch (err) {
                                    toastError(err);
                                } finally {
                                    setConnLoading(false);
                                }
                            }}
                        >
                            Importar
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            {importContactModalOpen && (
                <ContactImportWpModal
                    isOpen={importContactModalOpen}
                    handleClose={() => setImportContactModalOpen(false)}
                    selectedTags={selectedTags}
                    hideNum={hideNum}
                    userProfile={user.profile}
                />
            )}
        </MainContainer>
    );
};

export default Contacts;
